module.exports = __webpack_public_path__ + "h5/img/cs_05.70437823.jpeg";